import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import PageHero from "@/components/site/PageHero";
import BottomCTA from "@/components/site/BottomCTA";
import useReveal from "@/hooks/useReveal";

export default function Careers() {
  useReveal();
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white text-unik-ink">
      <SiteNav />
      <PageHero
        eyebrow={t("careers.heroEyebrow")}
        title={t("careers.heroTitle")}
        accent={t("careers.heroAccent")}
        sub={t("careers.heroSub")}
        bgImage="/assets/9dtf4cah_Career-top.jpg"
      />

      <section className="relative bg-white py-28 lg:py-36">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-20 items-center">
          <div className="lg:col-span-6" data-reveal>
            <div className="eyebrow text-[#14355a]">{t("careers.sectionEyebrow")}</div>
            <h2
              style={{
                fontSize: "clamp(2.25rem, 5vw, 4.5rem)",
                fontWeight: 500,
                lineHeight: "1.0",
              }}
              className="mt-6 font-display text-[#14355a] tracking-tight"
            >
              {t("careers.sectionTitle")}<br/>
              <span className="text-unik-gold">{t("careers.sectionAccent")}</span>
            </h2>
            <div className="mt-8 space-y-6 max-w-xl text-[17px] lg:text-[18px] leading-[1.95] text-black">
              {t("careers.sectionParagraphs", { returnObjects: true }).map((p, i) => (
                <p key={p.slice(0, 24)}>{p}</p>
              ))}
            </div>
            <Link
              to="/contact"
              className="link-rule mt-10 text-[#14355a] text-sm hover:text-unik-gold-soft"
              data-testid="careers-cta"
            >
              {t("common.contactUs")}
            </Link>
          </div>
          <div className="lg:col-span-6" data-reveal>
            <img
              src="/assets/gz4rrfrn_Career-image.jpg"
              alt=""
              className="w-full h-[60vh] lg:h-[72vh] object-cover"
            />
          </div>
        </div>
      </section>

      <BottomCTA
        eyebrow={t("careers.bottomCta.eyebrow")}
        title={t("careers.bottomCta.title")}
        accent={<><br/>{t("careers.bottomCta.accent")}</>}
        body={t("careers.bottomCta.body")}
        primary={{ label: t("careers.bottomCta.primary"), to: "/contact" }}
        secondary={{ label: t("careers.bottomCta.secondary"), to: "/about/who-we-are" }}
      />
      <SiteFooter />
    </div>
  );
}
